import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChild, TemplateRef } from '@angular/core';
import { DatePipe } from '@angular/common';
import {
  NgFlowchartCanvasDirective,
  NgFlowchartStepRegistry,
  NgFlowchart,
  NgFlowchartStepComponent
} from '@joelwenzel/ng-flowchart';
import { StatusStepComponent } from '../status-step/status-step.component';
import { CommonUtilty, GuidGenerator, InteractService } from 'app/BaseFramework';
import { ActionStepComponent } from '../action-step/action-step.component';
import { Router } from '@angular/router'
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { DataEntryStepComponent } from './data-entry-step/data-entry-step.component';
import { PolicyRejectComponent } from './policy-reject-step/policy-reject-step.component';
import { PolicyIssuenceStepComponent } from './policy-issuence-step/policy-issuence-step.component';
import { PayoutDetailsComponent } from '../payout-details/payout-details.component';
import { PayoutStepComponent } from './payout-step/payout-step.component';
import { ManualUnderwritingStepComponent } from './manual-underwriting-step/manual-underwriting-step.component';
import { ManualAdjudicationStepComponent } from './manual-adjudication-step/manual-adjudication-step.component';
import { AutoAdjudicationStepComponent } from './auto-adjudication-step/auto-adjudication-step.component';
import { InvestigationStepComponent } from './investigation-step/investigation-step.component';
import { AutoUnderwritingStepComponent } from './auto-underwriting-step/auto-underwriting-step.component';
// import { NgFlowchartCanvasService } from '@joelwenzel/ng-flowchart/lib/ng-flowchart-canvas.service';
@Component({
  selector: 'app-workflow-configurator',
  templateUrl: './workflow-configurator.component.html',
  styleUrls: ['./workflow-configurator.component.scss'],
  providers: [DatePipe]
})
export class WorkflowConfigurator implements OnInit {
  _currentComponentName = 'WorkflowConfigurator'
  workflowJSON = null
  title = 'workspace';
  eventType = ['Adjudication', 'Underwriting', 'Computation'
    , 'Correspondence', 'Eligibility', 'Payout',
    'Validation', 'Requirement', 'Custom']
  eventName = ['Gender Validation Rule', 'Age Validation Rule']
  callbacks: NgFlowchart.Callbacks = {};
  options: NgFlowchart.Options = {
    stepGap: 40,
    rootPosition: 'FREE'
  };

  @ViewChild('normalStep')
  normalStepTemplate: TemplateRef<any>;


  private _payloadInEdit = null
  set payloadInEdit(value: any) {
    if (this._payloadInEdit == null) {
      this._payloadInEdit = this.commonUtility.deepCopy(value)
    }
    else {
      throw "You cannot set payloadInEdit, since it's a constant and can be initialized only once"
    }
  }

  get payloadInEdit() {
    return this._payloadInEdit
  }

  workflowDetailsDynamicForm = [
    {
      "fieldName": "Workflow Name",
      "fieldKey": "workflowName",
      "fieldType": "INPUT",
      "lookupCd": null,
      "fieldGenericMapping": "baseDO-workflowName",
      "fieldMapping": "workflowDO-workflowName"
    },
    {
      "fieldName": "Application ID",
      "fieldKey": "applicationID",
      "fieldType": "INPUT",
      "lookupCd": null,
      "fieldGenericMapping": "baseDO-applicationID",
      "fieldMapping": "workflowDO-applicationID"
    },
    {
      "fieldName": "Company Name",
      "fieldKey": "companyName",
      "fieldType": "INPUT",
      "lookupCd": null,
      "fieldGenericMapping": "baseDO-companyName",
      "fieldMapping": "workflowDO-companyName",
      "disabled": true
    },
    {
      "fieldName": "Updated By",
      "fieldKey": "updatedBy",
      "fieldType": "Input",
      "lookupCd": null,
      "fieldGenericMapping": "baseDO-updatedBy",
      "fieldMapping": "workflowDO-updatedBy",
      "disabled": true
    }
  ]

  dataSet = [{}, {}];
  stateOrActionAlreadyExist = false;
  sampleJson =
    `{
        "root": {
            "id": "s1671016701539",
            "type": "state",
            "data": {
                "name": "PA Created",
                "icon": {
                    "name": "gateway",
                    "color": "blue"
                },
                "color": "yellow",
                "config": {
                    "message": null,
                    "severity": null
                }
            },
            "children": [
                {
                    "id": "s1671016703638",
                    "type": "action",
                    "data": {
                        "name": "Save without exception",
                        "icon": {
                            "name": "log-icon",
                            "color": "blue"
                        },
                        "color": "blue",
                        "config": {
                            "message": null,
                            "severity": null
                        }
                    },
                    "children": []
                },
                {
                    "id": "s1671016711207",
                    "type": "action",
                    "data": {
                        "name": "Save/Submit with Exception",
                        "icon": {
                            "name": "log-icon",
                            "color": "blue"
                        },
                        "color": "blue",
                        "config": {
                            "message": null,
                            "severity": null
                        }
                    },
                    "children": []
                }
            ]
        }
    }`

  workflowName = ""

  @ViewChild(NgFlowchartCanvasDirective)
  canvas: NgFlowchartCanvasDirective;

  disabled = false;

  constructor(private stepRegistry: NgFlowchartStepRegistry,
    public dataTransferService: InteractService,
    private commonUtil: GuidGenerator,
    private commonUtility: CommonUtilty,
    private router: Router,
    private notificationService: NzNotificationService,
    // private flowChartService: NgFlowchartCanvasService
    ) {
    this.callbacks.onDropError = this.onDropError;
    this.callbacks.onMoveError = this.onMoveError;
    this.callbacks.onDropStep = this.onDropStep.bind(this);
  }

  ngOnInit() {
    this.dynamicallyAddStepsToConfigure()
    this.dataTransferService.getEvents(event).subscribe(res => {
      if (res['actionPerformed'] == 'Delete') {
        this.onDelete(res['id'])
      }
      if (res['actionPerformed'] == 'StateChanged' || res['actionPerformed'] == 'ActionChanged') {
        this.reinstateStatusActions(res['guid']);
      }
    })
  }

  ngAfterViewInit() {
    this.registerSteps();
    this.showUpload();
  }

  private initializeWorkflowSteps() {
    let statusAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'state');
    let actionAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'action');
    let dataEntryStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'dataEntry');
    let manualAdjudicationStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'manualAdjudication');
    let autoAdjudicationStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'autoAdjudication');
    let manualUnderwritingStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'manualUnderwriting');
    let autoUnderwritingStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'autoUnderwriting');
    let payoutStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'payout');
    let policyIssuenceStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'policyIssuence');
    let policyRejectStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'policyReject');
    let investigationStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.type == 'investigation');

    if(investigationStepAvailable != -1){
      this.dataTransferService.workflowSteps[investigationStepAvailable].step.template = InvestigationStepComponent
    }
    if(statusAvailable != -1){
      this.dataTransferService.workflowSteps[statusAvailable].step.template = StatusStepComponent
    }
    if(actionAvailable != -1){
      this.dataTransferService.workflowSteps[actionAvailable].step.template = ActionStepComponent
    }
    if(dataEntryStepAvailable != -1){
      this.dataTransferService.workflowSteps[dataEntryStepAvailable].step.template = DataEntryStepComponent
    }
    if(manualAdjudicationStepAvailable != -1){
      this.dataTransferService.workflowSteps[manualAdjudicationStepAvailable].step.template = ManualAdjudicationStepComponent
    }
    if(autoAdjudicationStepAvailable != -1){
      this.dataTransferService.workflowSteps[autoAdjudicationStepAvailable].step.template = AutoAdjudicationStepComponent
    }
    if(manualUnderwritingStepAvailable != -1){
      this.dataTransferService.workflowSteps[manualUnderwritingStepAvailable].step.template = ManualUnderwritingStepComponent
    }
    if(autoUnderwritingStepAvailable != -1){
      this.dataTransferService.workflowSteps[autoUnderwritingStepAvailable].step.template = AutoUnderwritingStepComponent
    }
    if(payoutStepAvailable != -1){
      this.dataTransferService.workflowSteps[payoutStepAvailable].step.template = PayoutStepComponent
    }
    if(policyIssuenceStepAvailable != -1){
      this.dataTransferService.workflowSteps[policyIssuenceStepAvailable].step.template = PolicyIssuenceStepComponent
    }
    if(policyRejectStepAvailable != -1){
      this.dataTransferService.workflowSteps[policyRejectStepAvailable].step.template = PolicyRejectComponent
    }

  }

  private reinstateStatusActions(guid?) {

    let statusAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'State');
    let actionAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Action');
    let dataEntryStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Data Entry');
    let manualAdjudicationStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Manual Adjudication');
    let autoAdjudicationStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Auto Adjudicaton');
    let manualUnderwritingStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Manual Underwriting');
    let autoUnderwritingStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Auto underwriting');
    let payoutStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Payout');
    let policyIssuenceStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Policy Issuence');
    let policyRejectStepAvailable = this.dataTransferService.workflowSteps.findIndex(res => res.step.data.name == 'Policy Rejection');

    if (statusAvailable == -1) {
      let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'state')
      this.dataTransferService.workflowSteps.push(obj);
    }
    if (actionAvailable == -1) {
      let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'action')
      if(obj)
      this.dataTransferService.workflowSteps.push(obj);
    }
    // if (dataEntryStepAvailable == -1) {
    //   let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'dataEntry')
    //   if(obj)
    //   this.dataTransferService.workflowSteps.push(obj);
    // }
    // if (manualAdjudicationStepAvailable == -1) {
    //   let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'manualAdjudication')
    //   if(obj)
    //   this.dataTransferService.workflowSteps.push(obj);
    // }
    // if (autoAdjudicationStepAvailable == -1) {
    //   let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'autoAdjudication')
    //   if(obj)
    //   this.dataTransferService.workflowSteps.push(obj);
    // }
    // if (manualUnderwritingStepAvailable == -1) {
    //   let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'manualUnderwriting')
    //   if(obj)
    //   this.dataTransferService.workflowSteps.push(obj);
    // }
    // if (autoUnderwritingStepAvailable == -1) {
    //   let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'autoUnderwriting')
    //   if(obj)
    //   this.dataTransferService.workflowSteps.push(obj);
    // }
    // if (payoutStepAvailable == -1) {
    //   let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'payout')
    //   if(obj)
    //   this.dataTransferService.workflowSteps.push(obj);
    // }
    // if (policyIssuenceStepAvailable == -1) {
    //   let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'policyIssuence')
    //   if(obj)
    //   this.dataTransferService.workflowSteps.push(obj);
    // }
    // if (policyRejectStepAvailable == -1) {
    //   let obj = this.dataTransferService.mandatorySteps.find(res=> res.step.type == 'policyReject')
    //   if(obj)
    //   this.dataTransferService.workflowSteps.push(obj);
    // }
  }

  private registerSteps() {
    this.stepRegistry.registerStep('state', StatusStepComponent);
    this.stepRegistry.registerStep('action', ActionStepComponent);
    this.stepRegistry.registerStep('dataEntry', DataEntryStepComponent);
    this.stepRegistry.registerStep('policyReject', PolicyRejectComponent);
    this.stepRegistry.registerStep('policyIssuence', PolicyIssuenceStepComponent);
    this.stepRegistry.registerStep('payout', PayoutStepComponent);
    this.stepRegistry.registerStep('investigation', InvestigationStepComponent);
    this.stepRegistry.registerStep('manualUnderwriting', ManualUnderwritingStepComponent);
    this.stepRegistry.registerStep('manualAdjudication', ManualAdjudicationStepComponent);
    this.stepRegistry.registerStep('autoUnderwriting', AutoUnderwritingStepComponent);
    this.stepRegistry.registerStep('autoAdjudication', AutoAdjudicationStepComponent);
  }

  updateCurrentWorkflow() {
    let json = this.canvas.getFlow().toJSON(4)
    //this.dataTransferService.currentWorkflow.workflowDO['flowChartJSON'] = JSON.parse(json)
  }

  keyValuePairExists(json, key, value) {
    // Iterate over the properties of the object
    for (let prop in json) {
      // Check if the property is an object
      if (json[prop] !== null && typeof json[prop] === "object") {
        // Recursively call the keyValuePairExists function on the nested object
        if (this.keyValuePairExists(json[prop], key, value)) {
          return true;
        }
      } else {
        // Check if the property is the key we are looking for and if the corresponding value is the value we are looking for
        if (prop === key && json[prop] === value) {
          return true;
        }
      }
    }
  }

  // Start: Ng flowchart callbacks and library functions
  onDropError(error: NgFlowchart.DropError) {
    console.log(error);
  }

  onDropStep(event?: NgFlowchart.DropEvent, step?: any, flowchart?: any) {
    let valueExist;// = this.keyValuePairExists(this.dataTransferService.currentWorkflow.workflowDO['flowChartJSON'], 'name', event.step.data.name)
    if (valueExist) {
      console.log('Value already exist', event.step.data.name);
      this.reinstateStatusActions()
    }
    this.stateOrActionAlreadyExist = false
    this.updateCurrentWorkflow()
  }

  onDragMove(e) {
    console.log(e);
  }

  onMoveError(error: NgFlowchart.MoveError) {
    console.log(error);
  }

  clearData() {
    this.canvas.getFlow().clear();
  }

  showUpload(json?) {
    if (!json){}
     // this.canvas.getFlow().upload(JSON.stringify(this.dataTransferService.currentWorkflow.workflowDO['flowChartJSON']));
    else {
      json = JSON.parse(json)
      this.canvas.getFlow().upload(JSON.stringify(json));
    }
  }

  showFlowData() {
    let json = this.canvas.getFlow().toJSON(4);
    var x = window.open();
    x.document.open();
    x.document.write(
      '<html><head><title>Workflow JSON</title></head><body><pre>' +
      json +
      '</pre></body></html>'
    );
    x.document.close();
  }

  onGapChanged(event) {
    this.options = {
      ...this.options,
      stepGap: parseInt(event.target.value)
    };
  }

  onSequentialChange(event) {
    this.options = {
      ...this.options,
      isSequential: event.target.checked
    };
  }

  onDelete(id) {
    this.canvas
      .getFlow()
      .getStep(id)
      .destroy(true);
  }

  onEntityClick(data) {
    let stepInfo = this.canvas
      .getFlow()
      .getStep(data.id)
    console.log(stepInfo);

  }

  // End: Ng flowchart callbacks and library functions

  filterStepsArray(a) {
    return a.filter(res => res && (res.step.data.name == 'State'
      || res.step.data.name == 'Action'))
  }

  filterApplicationSpecificStepsArray(a){
    return a.filter(res=>res && (res.step.data.name == 'Data Entry'
      || res.step.data.name == 'Manual Adjudication'
      || res.step.data.name == 'Auto Adjudication'
      || res.step.data.name == 'Manual Underwriting'
      || res.step.data.name == 'Auto Underwriting'
      || res.step.data.name == 'Policy Issuence'
      || res.step.data.name == 'Policy Reject'
      || res.step.data.name == 'Investigation'
      || res.step.data.name == 'Payout')
      )
  }

  actionArray = []
  filterOnlyActions(obj) {
    if (obj['type'] == 'action')
      this.actionArray.push(obj.data.name)
    if (!obj.children) {
      return
    }
    obj.children.forEach(child => this.filterOnlyActions(child))
  }

  saveClicked() {
    this.updateCurrentWorkflow()
    let workflowExistInList;// = this.dataTransferService.workflowList.findIndex(res => res['workflowDO'].workflowName == this.dataTransferService.currentWorkflow.workflowDO.workflowName)
    if (workflowExistInList != -1) {
      this.dataTransferService.workflowList.splice(workflowExistInList, 1)
    }

    //this.dataTransferService.workflowList.push(this.dataTransferService.currentWorkflow)
    this.router.navigateByUrl("/app/claims/inbox/search-config");
  }

  submitClicked() {
   // this.dataTransferService.currentWorkflow.workflowDO.statusCd = 'Complete'
    this.saveClicked()
  }

  cancelClicked() {
    this.router.navigateByUrl("/app/claims/inbox/search-config");
  }

  //modal functions
  isVisible
  showModal(): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
  }
  //

  addWorkflowEventMapping() {
    // this.dataTransferService.currentWorkflow.workflowDO.workflowEventMapping.push({
    //   actionName: "",
    //   eventType: "",
    //   eventName: ""
    // })
  }

  workflowDetailsChanged(componentData) {
    console.log(componentData);
  }

  dynamicallyAddStepsToConfigure() {
    let workflowSteps_claims = [
      {
        paletteName: 'State',
        step: {
          template: StatusStepComponent,
          type: 'state',
          data: {
            name: 'State',
            guid: new GuidGenerator().setGuid()
          }
        }
      },
      {
        paletteName: 'Action',
        step: {
          template: ActionStepComponent,
          type: 'action',
          data: {
            name: 'Action',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Data Entry',
        step: {
          template: DataEntryStepComponent,
          type: 'dataEntry',
          data: {
            name: 'Data Entry',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Manual Adjudication',
        step: {
          template: ManualAdjudicationStepComponent,
          type: 'manualAdjudication',
          data: {
            name: 'Manual Adjudication',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Auto Adjudication',
        step: {
          template: AutoAdjudicationStepComponent,
          type: 'autoAdjudication',
          data: {
            name: 'Auto Adjudication',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Investigation',
        step: {
          template: InvestigationStepComponent,
          type: 'investigation',
          data: {
            name: 'Investigation',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Payout',
        step: {
          template: PayoutStepComponent,
          type: 'payout',
          data: {
            name: 'Payout',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      }
    ]
    let workflowSteps_nbu = [
      {
        paletteName: 'State',
        step: {
          template: StatusStepComponent,
          type: 'state',
          data: {
            name: 'State',
            guid: new GuidGenerator().setGuid()
          }
        }
      },
      {
        paletteName: 'Action',
        step: {
          template: ActionStepComponent,
          type: 'action',
          data: {
            name: 'Action',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Data Entry',
        step: {
          template: DataEntryStepComponent,
          type: 'dataEntry',
          data: {
            name: 'Data Entry',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Manual Underwriting',
        step: {
          template: ManualUnderwritingStepComponent,
          type: 'manualUnderwriting',
          data: {
            name: 'Manual Underwriting',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Auto Underwriting',
        step: {
          template: AutoUnderwritingStepComponent,
          type: 'autoUnderwriting',
          data: {
            name: 'Auto Underwriting',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Policy Issuence',
        step: {
          template: PolicyIssuenceStepComponent,
          type: 'policyIssuence',
          data: {
            name: 'Policy Issuence',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Policy Reject',
        step: {
          template: PolicyRejectComponent,
          type: 'policyReject',
          data: {
            name: 'Policy Reject',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      }
    ]
    let mandatorySteps_claims = [
      {
        paletteName: 'State',
        step: {
          template: StatusStepComponent,
          type: 'state',
          data: {
            name: 'State',
            guid: new GuidGenerator().setGuid()
          }
        }
      },
      {
        paletteName: 'Action',
        step: {
          template: ActionStepComponent,
          type: 'action',
          data: {
            name: 'Action',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Data Entry',
        step: {
          template: DataEntryStepComponent,
          type: 'dataEntry',
          data: {
            name: 'Data Entry',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Manual Adjudication',
        step: {
          template: ManualAdjudicationStepComponent,
          type: 'manualAdjudication',
          data: {
            name: 'Manual Adjudication',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Auto Adjudication',
        step: {
          template: AutoAdjudicationStepComponent,
          type: 'autoAdjudication',
          data: {
            name: 'Auto Adjudication',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Investigation',
        step: {
          template: InvestigationStepComponent,
          type: 'investigation',
          data: {
            name: 'Investigation',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Payout',
        step: {
          template: PayoutStepComponent,
          type: 'payout',
          data: {
            name: 'Payout',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      }
    ]
    let mandatorySteps_nbu = [
      {
        paletteName: 'State',
        step: {
          template: StatusStepComponent,
          type: 'state',
          data: {
            name: 'State',
            guid: new GuidGenerator().setGuid()
          }
        }
      },
      {
        paletteName: 'Action',
        step: {
          template: ActionStepComponent,
          type: 'action',
          data: {
            name: 'Action',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Data Entry',
        step: {
          template: DataEntryStepComponent,
          type: 'dataEntry',
          data: {
            name: 'Data Entry',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Manual Underwriting',
        step: {
          template: ManualUnderwritingStepComponent,
          type: 'manualUnderwriting',
          data: {
            name: 'Manual Underwriting',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Auto Underwriting',
        step: {
          template: AutoUnderwritingStepComponent,
          type: 'autoUnderwriting',
          data: {
            name: 'Auto Underwriting',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Policy Issuence',
        step: {
          template: PolicyIssuenceStepComponent,
          type: 'policyIssuence',
          data: {
            name: 'Policy Issuence',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      },
      {
        paletteName: 'Policy Reject',
        step: {
          template: PolicyRejectComponent,
          type: 'policyReject',
          data: {
            name: 'Policy Reject',
            guid: new GuidGenerator().setGuid(),
            workflowEventMapping: []
          }
        }
      }
    ]
    // if (this.dataTransferService.currentWorkflow.workflowDO.applicationID &&
    //   this.dataTransferService.currentWorkflow.workflowDO.applicationID == 'Claims') {
    //   this.dataTransferService.workflowSteps = this.commonUtility.deepCopy(workflowSteps_claims)
    //   this.dataTransferService.mandatorySteps = this.commonUtility.deepCopy(mandatorySteps_claims)
    //   // this.flowChartService.reRender()
    // } else if (this.dataTransferService.currentWorkflow.workflowDO.applicationID &&
    //   this.dataTransferService.currentWorkflow.workflowDO.applicationID == 'NBU') {
    //   this.dataTransferService.workflowSteps = this.commonUtility.deepCopy(workflowSteps_nbu)
    //   this.dataTransferService.mandatorySteps = this.commonUtility.deepCopy(mandatorySteps_nbu)
    //   // this.flowChartService.reRender()
    // }
    this.initializeWorkflowSteps();
  }

}